export default {
  en: [
    { label: 'shin', violation: 'Sharing Inapproriate Things' },
    { label: 'susi', violation: 'Suicide or Self-injury' },
    { label: 'nudi', violation: 'Nudity' },
    { label: 'viol', violation: 'Violence' },
    { label: 'hara', violation: 'Harassment' },
    { label: 'hasp', violation: 'Hate Speech' },
    { label: 'spam', violation: 'Spam' },
    { label: 'smth', violation: 'Something Else' },
  ],
  it: [
    { label: 'shin', violation: 'Condividere Cose Inappropriate' },
    { label: 'susi', violation: 'Suicidio' },
    { label: 'nudi', violation: 'Nudità' },
    { label: 'viol', violation: 'Violenza' },
    { label: 'hara', violation: 'Molestia' },
    { label: 'hasp', violation: "Incitamento all'Odio" },
    { label: 'spam', violation: 'Spam' },
    { label: 'smth', violation: "Qualcos'altro" },
  ],
};
